<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="记录"
      :expand-all-row="true"
      :page="page"
      tip="点击状态可处理考勤异常"
      :query-params="params"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="学期名称">
          <el-select v-model="params.TermId" @change="termChange" size="mini">
            <el-option
              v-for="item in termList"
              :key="item.TermId"
              :value="item.TermId"
              :label="item.TermName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学生姓名">
          <el-input size="mini" v-model="params.FullName" style="width:184px;" clearable placeholder="请填写学生姓名" />
        </el-form-item>
        <el-form-item label="年级">
          <el-select v-model="params.GradeId" size="mini" @change="getClass" clearable>
            <template v-for="(i,index) in grades">
              <el-option :key="index" :value="i.GradeId" :label="i.Grade"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="班级">
          <el-select v-model="params.ClassId" size="mini" clearable>
            <template v-for="(i,index) in classes">
              <el-option :key="index" :value="i.ClassId" :label="i.ClassName"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="开始日期">
          <el-date-picker
            size="mini"
            v-model="params.StartDate"
            placeholder="请选择日期"
            style="width:184px;"
            clearable
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item label="结束日期">
          <el-date-picker
            size="mini"
            v-model="params.EndDate"
            placeholder="请选择日期"
            style="width:184px;"
            clearable
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item label="节次类型">
          <el-select size="mini" v-model="params.SectionType" clearable>
            <el-option :value="0" label="上课节次"></el-option>
            <el-option :value="1" label="留宿节次"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="处理结果">
          <el-select size="mini" v-model="params.HandleType" clearable>
            <el-option value="病假"></el-option>
            <el-option value="事假"></el-option>
            <el-option value="公假"></el-option>
            <el-option value="走读"></el-option>
            <el-option value="校本课程"></el-option>
            <el-option value="校内其他"></el-option>
            <el-option value="医务室"></el-option>
            <el-option value="心理站"></el-option>
            <el-option value="迟到"></el-option>
            <el-option value="无故缺勤"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select size="mini" v-model="params.HandleStatus">
            <el-option :value="0" label="待处理"></el-option>
            <el-option :value="1" label="已处理"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="FullName" label="姓名" :width="isMB?62:100"/>
        <el-table-column label="班级" :width="isMB?72:100">
          <template slot-scope="{row}">
            <span>{{row.Grade + row.Class}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="AttendanceDate" label="日期" :width="isMB?83:100">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.AttendanceDate)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="SectionName" label="节次" :width="isMB?70:100"/>
        <el-table-column prop="SectionType" label="节次类型">
          <template slot-scope="{row}">
            <span v-if="row.SectionType==0">上课节次</span>
            <span v-else-if="row.SectionType==1">留宿节次</span>
          </template>
        </el-table-column>
        <el-table-column prop="Remark" label="具体情况" min-width="140" />
        <!-- <el-table-column prop="HandleResult" label="处理结果" width="90" align="center">
          <template slot-scope="{row}">
            <el-tag type="success" size="small" v-if="row.HandleResult==1">正常缺勤</el-tag>
            <el-tag type="danger" size="small" v-else-if="row.HandleResult==2">迟到</el-tag>
            <el-tag type="danger" size="small" v-else-if="row.HandleResult==3">无故缺勤</el-tag>
          </template>
        </el-table-column> -->
        <el-table-column prop="HandleType" label="处理结果" width="90" align="center">
          <template slot-scope="{row}">
            <el-tag type="success" size="small" v-if="row.HandleType=='病假'||row.HandleType=='事假'||row.HandleType=='公假'||row.HandleType=='校内其他'||row.HandleType=='走读'||row.HandleType=='校本课程'||row.HandleType=='其他'||row.HandleType=='校内竞赛'">{{row.HandleType}}</el-tag>
            <el-tag type="danger" size="small" v-else-if="row.HandleType=='医务室'||row.HandleType=='心理站'||row.HandleType=='迟到'||row.HandleType=='无故缺勤'">{{row.HandleType}}</el-tag>
            <el-tag type="success" size="small" v-else-if="row.HandleResult==1">正常缺勤</el-tag>
            <el-tag type="danger" size="small" v-else-if="row.HandleResult==2">迟到</el-tag>
            <el-tag type="danger" size="small" v-else-if="row.HandleResult==3">无故缺勤</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="HandleStatus" label="状态" :width="isMB?60:100" align="center" fixed="right" v-if="!$permission.canWrite()">
          <template slot-scope="{row}">
            <el-tag type="warning" size="small" v-if="row.HandleStatus==0">待处理</el-tag>
            <el-tag type="success" size="small" v-else-if="row.HandleStatus==1">已处理</el-tag>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
    <export-dialog ref="exportDialog" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import termApi from "@/api/ed/term";
import exportDialog from "./exportDialog";

export default {
  mixins: [listMixin],
  components: { list, exportDialog },
  data() {
    return {
      api: require("@/api/st/attendance").default,
      grade_api: require("@/api/ed/grade").default,
      class_api: require("@/api/ed/class").default,
      params: {
        FullName: "",
        ClassTeacherId: null,
        StartDate: "",
        EndDate: "",
        TermId: null,
        GradeId: null,
        ClassId: null,
        Statuses: [0,2],
        UnNormal: true,
        SectionType: null,
        // HandleResult: null, //其他正常缺勤/迟到/无故缺勤
        HandleType: "",
        HandleStatus: 0, //待处理/已处理
      },
      isMB: this.$store.state.isMB,
      termApi,
      termList: [],
      grades: [],
      classes: [],
    };
  },
  beforeMount() {
    let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
    this.params.ClassTeacherId = loginInfo.TeacherId;
    this.params.TermId = loginInfo.TermId;
    this.termApi.list().then((res) => {
      this.termList = res.Data || [];
      if (res.Data.length > 0) {
        if (!this.params.TermId) {
          this.params.TermId = res.Data[0].TermId;
        }
        sessionStorage.setItem("termId", this.params.TermId);
        if (this.params.TermId < 0) {
          this.query({ TermId: res.Data[0].TermId });
        }
      }
    });
    this.getGrade();
  },
  methods: {
    onExport() {
      this.api.export(this.$commonJs.obj.removeNullKey(this.$refs.list.tempQueryParams));
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
    termChange(e) {
      sessionStorage.setItem("termId", e);
      let t = this.termList.find((x) => {
        if (e == x.TermId) {
          return x;
        }
      });
      this.params.ClassId = null;
      this.getClass();
      this.query({
        TermId: e,
        FullName: this.params.FullName,
        ClassTeacherId: this.params.TeacherId,
        StartDate: this.params.StartDate,
        EndDate: this.params.EndDate,
      });
    },
    getGrade() {
      this.grade_api.list().then((res) => {
        this.grades = res.Data;
      });
    },
    getClass() {
      this.params.ClassId = null;
      if(!this.params.GradeId) {
        this.classes = [];
        return;
      }
      var params = { GradeId: this.params.GradeId, TermId: this.params.TermId };
      this.class_api.list(params).then((res) => {
        this.classes = res.Data;
      });
    },
  },
};
</script>